import { Link } from "react-router-dom";
import { timeline } from "@/mocks/timeline";

const TimelineSection = () => (
  <section className="bg-foreground-950">
    <div className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 border-t-2 border-accent-500 pt-5 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="font-label text-xs tracking-[0.28em] text-accent-400">年代索引</p>
          <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-background-50 md:text-3xl">
            从哪一年开始翻？
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-300">
            按事件发生年份归档。每个年代区间下面，都有一条最常被点开的条目。
          </p>
        </div>
        <Link
          to="/archive"
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap font-label text-sm text-accent-400 transition-colors hover:text-accent-300"
        >
          按年份浏览
          <i className="ri-arrow-right-line text-base"></i>
        </Link>
      </div>

      <ol className="relative mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {timeline.map((item, index) => (
          <li key={item.span} className="relative">
            <span className="absolute -top-6 left-0 h-3 w-3 rounded-full bg-accent-500"></span>
            <span className="absolute -top-[18px] left-0 h-px w-full bg-background-100/20"></span>
            <Link to={`/archive?era=${item.span}`} className="group block pt-2">
              <p className="font-heading text-3xl font-black text-background-50 transition-colors group-hover:text-accent-400">
                {item.span}
              </p>
              <p className="mt-1 font-label text-xs tracking-[0.2em] text-background-400">
                {item.label}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-background-300">{item.note}</p>
              <p className="mt-4 flex items-center gap-2 font-label text-xs text-secondary-300">
                <span className="rounded-sm bg-background-100/10 px-2 py-0.5">
                  {item.count} 条
                </span>
              </p>
              <p className="mt-3 flex items-start gap-2 border-t border-background-100/15 pt-3 text-xs leading-relaxed text-background-300">
                <i className="ri-price-tag-3-line mt-0.5 text-accent-500"></i>
                {item.highlight}
              </p>
              <span className="sr-only">第 {index + 1} 个年代区间</span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default TimelineSection;